// AUTH ACTIONS
export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const PASSWORD_RESETED = "PASSWORD_RESETED";
export const PASSWORD_CHANGED = "PASSWORD_CHANGED";
export const SET_USER_ROLES = "SET_USER_ROLES";
export const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS";

// SURVEYS ACTIONS
export const GET_USER_SURVEYS_SESSIONS = "GET_USER_SURVEYS_SESSIONS";
export const GET_USER_SURVEY = "GET_USER_SURVEY";

// ACCOUNT ACTIONS
export const SET_CURRENT_ACCOUNT = "SET_CURRENT_ACCOUNT";

// INFO ACTINS
export const OPEN_INFO = "OPEN_INFO";
export const CLOSE_INFO = "CLOSE_INFO";
export const OPEN_LOADER = "OPEN_LOADER";
export const CLOSE_LOADER = "CLOSE_LOADER";

// VIDEO ACTIONS
export const OPEN_VIDEO = "OPEN_VIDEO";
export const CLOSE_VIDEO = "CLOSE_VIDEO";

// RECOGNITION IMAGE ACTIONS
export const SET_CUSTOM_IMAGES = "SET_CUSTOM_IMAGES";

// AI WORKFLOWS ACTIONS
export const SET_WORKFLOWS_IDS = "SET_WORKFLOWS_IDS";

// POLICIES ACTIONS
export const SET_AVAILABLE_POLICIES = "SET_AVAILABLE_POLICIES";

// SLACK ACTIONS
export const SET_AVAILABLE_CHANNELS = "SET_AVAILABLE_CHANNELS";

// USERS ACTIONS
export const SET_USERS = "SET_USERS";
export const ADD_USER = "ADD_USER";
export const UPDATE_USER = "UPDATE_USER";
export const REMOVE_USER = "REMOVE_USER";
export const USERS_LOADING = "USERS_LOADING";
export const CLEAR_USERS = "CLEAR_USERS";
